<span class="form-label">
  <span translate>Range</span>&nbsp;
  @if (isInvalidRange) {
    <span [title]="'Invalid range'|translate">
      <i class="fa-solid fa-circle-exclamation"></i>
    </span>
  }
</span>
<div class="form-row">
  <div class="col-12 col-md-6">
    <div class="input-group">
      <div class="input-group-prepend">
        <span class="input-group-text">
          <span class="fa-solid fa-arrow-down"></span>
        </span>
      </div>
      <input
        (change)="onRangeChange()"
        [(ngModel)]="minY"
          [ngClass]="{
                      'is-invalid': isInvalidRange,
                       'is-valid': !isInvalidRange
                       }"
        [placeholder]="'Min.'|translate"
        class="form-control"
        type="number">
      </div>
    </div>
    <div class="col-12 col-md-6">
      <div class="input-group">
        <div class="input-group-prepend">
          <span class="input-group-text">
            <span class="fa-solid fa-arrow-up"></span>
          </span>
        </div>
        <input
          (change)="onRangeChange()"
          [(ngModel)]="maxY"
          [ngClass]="{
                      'is-invalid': isInvalidRange,
                       'is-valid': !isInvalidRange
                       }"
          [placeholder]="'Max.'|translate"
          class="form-control"
          type="number">
        </div>
      </div>
    </div>

